import {
  goalInboxID,
  GroupByMode,
  HabitGroupBy,
  ID,
  lifeAreaOtherID,
  UserSettings,
} from '@griply/types';

const storedNullKey = 'null';

const remapSentinelKey = (
  sorting: Record<ID, ID[]> | undefined,
  sentinel: ID,
): Record<ID, ID[]> => {
  if (!sorting) {
    return {};
  }
  return Object.entries(sorting).reduce<Record<ID, ID[]>>(
    (accumulator, [key, value]) => {
      accumulator[key === storedNullKey ? sentinel : key] = value;
      return accumulator;
    },
    {},
  );
};

export const getHabitsSidePanelCustomOrder = (
  habitGroupBy: HabitGroupBy | undefined,
  habitSorting: ID[] | null | undefined,
  habitGroupSorting: UserSettings['habitGroupSorting'],
): Record<ID, ID[]> => {
  if (habitGroupBy === HabitGroupBy.Goal) {
    return remapSentinelKey(habitGroupSorting?.goal?.sorting, goalInboxID);
  }
  if (habitGroupBy === HabitGroupBy.LifeArea) {
    return remapSentinelKey(
      habitGroupSorting?.lifeArea?.sorting,
      lifeAreaOtherID,
    );
  }
  if (habitGroupBy === HabitGroupBy.Priority) {
    return habitGroupSorting?.priority?.sorting ?? {};
  }
  return { [GroupByMode.None]: habitSorting ?? [] };
};
